import { individualWinner } from '@/helpers/constant';
import {
  IRecyleBlukData,
  IRecyleIndividualData,
} from '@/typescript/interfaces/reports.interface';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Pipe,
  PipeTransform,
  QueryList,
  Renderer2,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuctionService } from '@services/auction/auction.service';
import { ReportService } from '@services/report/report.service';
import { SharedService } from '@services/shared/shared.service';
import { TitleService } from '@services/title.service';
import { UserService } from '@services/user/user.service';
import { DataTableDirective } from 'angular-datatables';
import { Observable, of, Subscription, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ReportLoadingService } from './report-loading.service';
import {
  bulkColumns,
  individualColumns,
  prepareBulkTableData,
  prepareIndividualTableData,
  theadsBulk,
  theadsIndividuals,
} from './reports-table.defination';
import { LoadingService } from '@services/loading/loading.service';

type TAjaxParameter = Parameters<
  Extract<DataTables.Settings['ajax'], Function>
>;

type TFilterdAjaxParameter = TAjaxParameter extends [infer A, infer B, infer C]
  ? [B, C]
  : never;

type TAjaxData = {
  start: number;
  length: number;
  [key: string]: unknown;
};

// type TDataTablesSettings = Omit<DataTables.Settings, 'ajax'> & {
//   ajax: (data: TAjaxData, ...args: TFilterdAjaxParameter) => void;
//   [key: string]: unknown;
// };
type TDataTablesSettings = DataTables.Settings & {
  [key: string]: unknown;
};

export const commonDtOptions = {
  pagingType: 'simple_numbers',
  serverSide: true,
  processing: true,
  dom: 'Blfrtip',
  ordering: false,
  lengthChange: true,
  pageLength: 10,
  lengthMenu: [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 240, 280,
    300, 400, 500,
  ],
  language: {
    processing: '<div class="custom-loader"><div class="spinner"></div><div class="loading-text">Loading data ...</div></div>'
  },
};

export type TReportTab = 'individual' | 'individualBatch' | 'bulk';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [ReportLoadingService],
})
export class ReportsComponent implements OnInit, AfterViewInit, OnDestroy {
  transform(value: string): string {
    return value ? value.replace(/_/g, ' ') : value;
  }
  @ViewChildren(DataTableDirective) DT: QueryList<DataTableDirective>;

  public winnerList: object[] = [];
  public env: string = environment.forntend_url;
  public imgUrl: string = '';
  public imgBaseUrl: string = environment.imgBaseUrl;
  public fallBackImg: string;
  public userFallBackImg: string;
  public loading: boolean = false;
  public approveStatus: boolean | null;
  public checkingValue = [null, true, false];
  public individualAuctions$: Observable<IRecyleIndividualData[]> = of([]);
  public individualLoading: boolean = false;
  public individualBatchAuctions: object[] = [];
  public bulkAuctions$: Observable<IRecyleBlukData[]> = of([]);

  public bulkLoading: boolean = false;
  public individualLadda: boolean = false;
  public bulkLadda: boolean = false;
  public headingOrder = individualWinner;
  public dtOptions: TDataTablesSettings = {};
  public dtIndividualOptions: TDataTablesSettings = {};
  public theadsIndividuals = theadsIndividuals;
  public theadsBulk = theadsBulk;
  public dtBulkOptions: TDataTablesSettings = {};
  public indivdualPage = 1;
  public indivdualLimit = 10;
  public blukPage = 1;
  public blukLimit = 10;

  // --- Tab state ---------------------------------------------------------
  public activeTab: TReportTab = 'individual';

  private subscriptions = new Subscription();

  constructor(
    private renderer: Renderer2,
    public userService: UserService,
    public auctionService: AuctionService,
    public reportService: ReportService,
    public sharedService: SharedService,
    private router: Router,
    private titleService: TitleService,
    public loadingService: ReportLoadingService
  ) {
    this.titleService.updateTitle('Auction Purchase Request');
    this.fallBackImg = this.env + 'assets/img/car-placeholder.png';
    this.userFallBackImg = this.env + 'assets/img/user-placeholder.png';

    this.dtOptions = {
      // server-side mode so DataTables requests pages from the server
      serverSide: true,
      processing: true,
      paging: true,
      pagingType: 'simple_numbers',
      bLengthChange: false,
      bInfo: false,
      bSortable: false,
      dom: 'Bfrtip',
      columnDefs: [{ orderable: false, targets: '_all' }],

      // pageLength: set per-table in dtIndividualOptions/dtBulkOptions
      buttons: ['csv', 'excel'],
      language: {
        processing: '<div class="custom-loader"><div class="spinner"></div><div class="loading-text">Loading data ...</div></div>'
      },
    };
  }

  ngOnInit(): void {
    this.dtIndividualOptions = this.geWinnerList('individual');
    this.dtBulkOptions = this.geWinnerList('group');
  }

  /**
   * Switches the active report tab. DataTables are already initialized
   * up front (they're just hidden/shown via CSS), so no re-render is
   * required when switching — but if you notice column widths collapsing
   * on a hidden-then-shown table, call `.columns.adjust()` on the relevant
   * DataTableDirective instance from `this.DT` here.
   */
  setActiveTab(tab: TReportTab): void {
    this.activeTab = tab;
  }

  ngAfterViewInit(): void {
    this.renderer.listen('document', 'click', (event) => {
      if (event.target && event.target.closest('[data-href]')) {
        const auctionId = event.target
          .closest('[data-href]')
          .getAttribute('data-href');
        console.log(auctionId, 'auctionId');
        this.router.navigate([`/dashboard/auction-details/${auctionId}`]);
      }
      if (
        event.target &&
        event.target.closest('[data-action="approve-individual"]')
      ) {
        const btn = event.target.closest('[data-action="approve-individual"]');
        const auctionId = btn.getAttribute('data-auction-id');
        console.log(auctionId, 'auctionId');
        this.updateStatus(auctionId, '1', btn);
        // this.router.navigate([`/auction-details/${auctionId}`]);
      }
      if (
        event.target &&
        event.target.closest('[data-action="reject-individual"]')
      ) {
        const btn = event.target.closest('[data-action="reject-individual"]');
        const auctionId = btn.getAttribute('data-auction-id');
        this.updateStatus(auctionId, '0', btn);
        // this.router.navigate([`/auction-details/${auctionId}`]);
      }
      if (
        event.target &&
        event.target.closest('[data-action="approve-bluk"]')
      ) {
        const btn = event.target.closest('[data-action="approve-bluk"]');
        const auctionId = btn.getAttribute('data-auction-id');
        this.updateStatus(auctionId, '1', btn);
        // this.router.navigate([`/auction-details/${auctionId}`]);
      }
      if (event.target && event.target.closest('[data-action="reject-bluk"]')) {
        const btn = event.target.closest('[data-action="reject-bluk"]');
        const auctionId = btn.getAttribute('data-auction-id');
        this.updateStatus(auctionId, '0', btn);
        // this.router.navigate([`/auction-details/${auctionId}`]);
      }
      if (
        event.target &&
        event.target.closest('[data-action="individual-recycle"]')
      ) {
        const btn = event.target.closest('[data-action="individual-recycle"]');
        const auctionId = event.target
          .closest('[data-action="individual-recycle"]')
          .getAttribute('data-auction-id');
        this.recycleIndividualAuction(auctionId, btn);
        // this.router.navigate([`/auction-details/${auctionId}`]);
      }
      if (
        event.target &&
        event.target.closest('[data-action="recycle-bulk"]')
      ) {
        const btn = event.target.closest('[data-action="recycle-bulk"]');
        const auctionId = event.target
          .closest('[data-action="recycle-bulk"]')
          .getAttribute('data-auction-id');
        this.recycleBulkAuction(auctionId, btn);
        // this.router.navigate([`/auction-details/${auctionId}`]);
      }
    });
  }

  geWinnerList(entity_type: 'individual' | 'group'): TDataTablesSettings {
    // if (entity_type === 'individual') this.individualLoading = true;
    // if (entity_type === 'group') this.bulkLoading = true;
    // (IRecyleIndividualData | IRecyleBlukData)[];

    if (entity_type === 'individual') {
      const params = {
        page: this.indivdualPage || 1,
        limit: this.indivdualLimit || 10,
        entity_type,
      };

      return {
        ...this.dtOptions,
        columns: individualColumns,
        pageLength: params?.limit,
        displayStart: (params?.page - 1) * params?.limit,

        ajax: (dataTablesParameters: any, callback) => {
          const start = Number(dataTablesParameters?.start ?? 0);
          const length = Number(
            dataTablesParameters?.length ?? this.indivdualLimit
          );
          const currentPage = Math.floor(start / (length || 1)) + 1;

          this.indivdualPage = currentPage;
          this.indivdualLimit = length;
          // const currentPage =
          //   dataTablesParameters?.['start'] / dataTablesParameters.length + 1;
          // const currentLimit = dataTablesParameters.length;

          // this.indivdualPage++;
          // this.indivdualLimit++;

          const baseParams = { limit: length, page: currentPage, entity_type };

          this.individualAuctions$ = this.userService
            .getWinnerReportList<IRecyleIndividualData[]>(baseParams)
            .pipe(
              map((res) => {
                const tableData = prepareIndividualTableData(res);
                callback({
                  recordsTotal: res?.[0]?.['total_rows'] || 0,
                  recordsFiltered: res?.[0]?.['total_rows'] || 0,
                  data: tableData,
                });
                return this.vehicleName(res);
              }),
              catchError(() => {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
                return throwError((error: Error) => error);
              })
            );

          this.subscriptions.add(this.individualAuctions$.subscribe());
        },
      };
    }

    // if (entity_type === 'group') {
    const params = {
      page: this.blukPage || 1,
      limit: this.blukLimit || 10,
      entity_type,
    };

    return {
      ...this.dtOptions,
      columns: bulkColumns,
      pageLength: params?.limit,
      displayStart: (params?.page - 1) * params?.limit,

      ajax: (dataTablesParameters: any, callback) => {
        const start = Number(dataTablesParameters?.start ?? 0);
        const length = Number(
          dataTablesParameters?.length ?? this.indivdualLimit
        );
        const currentPage = Math.floor(start / (length || 1)) + 1;

        this.indivdualPage = currentPage;
        this.indivdualLimit = length;
        // const currentPage =
        //   dataTablesParameters?.['start'] / dataTablesParameters.length + 1;
        // const currentLimit = dataTablesParameters.length;

        // this.indivdualPage++;
        // this.indivdualLimit++;

        const baseParams = { limit: length, page: currentPage, entity_type };

        this.bulkAuctions$ = this.userService
          .getWinnerReportList<IRecyleBlukData[]>(baseParams)
          .pipe(
            map((res) => {
              const tableData = prepareBulkTableData(res);
              callback({
                recordsTotal: res?.[0]?.['total_rows'] || 0,
                recordsFiltered: res?.[0]?.['total_rows'] || 0,
                data: tableData,
              });
              return this.bulkVehicleNo(res);
            }),
            catchError(() => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
              return throwError((error: Error) => error);
            })
          );
        this.subscriptions.add(this.bulkAuctions$.subscribe());
      },
    };
    // }
  }

  vehicleName(list: IRecyleIndividualData[]) {
    const newList = list.slice(0);
    return newList.map((item) => {
      // delete item?.['description_data']?.['Description'];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'description'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'Finance status'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'Finance Status'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'test_drive_video'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'Test Drive Video'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'vehicle_360_link'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'Vehicle 360 link'
      // ];
      // delete item?.['auction_information']?.[0]?.['description_data']?.[
      //   'price'
      // ];

      return {
        ...item,
        vehicleName: this.sharedService.InventoryName(
          item?.['description_data']
        ),
      };
    });
  }

  updateStatus(
    auctionId: string,
    status: string,
    button?: Element | null
  ): void {
    if (button) this.setActionButtonLoading(button, true);

    this.auctionService
      .updateStatus(auctionId, status)
      .pipe(
        finalize(() => button && this.setActionButtonLoading(button, false))
      )
      .subscribe((res) => {
        if (res['success'] === true) {
          window.location.reload();
        }
      });
  }

  private setActionButtonLoading(
    button: Element | null,
    loading: boolean,
    label?: string
  ) {
    if (!button) return;
    const btn = button as HTMLElement;

    if (loading) {
      if (!btn.getAttribute('data-original-html')) {
        btn.setAttribute('data-original-html', btn.innerHTML);
      }
      btn.setAttribute('disabled', 'true');
      btn.style.minWidth = `${btn.clientWidth}px`;
      // btn.setAttribute("width",);
      // const text = label || 'Processing...';
      btn.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
    } else {
      const original = btn.getAttribute('data-original-html');
      if (original) {
        btn.innerHTML = original;
        btn.removeAttribute('data-original-html');
      }
      btn.removeAttribute('disabled');
    }
  }

  // batchVehicleNo(batch: object[]) {
  //   batch.forEach((item, index) => {
  //     this.individualBatchAuctions[index]['numberOfVehicle'] =
  //       item['auction_information']?.[0]['ProductInfo']?.length;
  //   });
  // }

  bulkVehicleNo(list: IRecyleBlukData[]) {
    const newList = list.slice(0);
    return newList.map((item) => ({
      ...item,
      numberOfVehicle: item['bulkInfo']?.length,
    }));
  }

  // separateAuction(
  //   entity_type: 'group' | 'individual',
  //   auctions: (IRecyleIndividualData | IRecyleBlukData)[]
  // ) {
  //   if (entity_type === 'individual')
  //     this.individualAuctions = auctions as IRecyleIndividualData[];
  //   if (entity_type === 'group')
  //     this.bulkAuctions = auctions as IRecyleBlukData[];

  //   this.vehicleName();
  //   this.batchVehicleNo(this.individualBatchAuctions);
  //   this.bulkVehicleNo(this.bulkAuctions);
  // }

  recycleIndividualAuction(auctionId: string, btn: HTMLButtonElement | null) {
    // this.individualLadda = true;

    this.setActionButtonLoading(btn, true);

    this.reportService
      .vehicleRecycle(auctionId)
      .pipe(finalize(() => this.setActionButtonLoading(btn, false)))
      .subscribe((res) => {
        if (res['success']) {
          this.router.navigate([`/dashboard/auction/edit/${auctionId}`]);
          localStorage.setItem("for-recyle", "true")
        }

      });
  }

  recycleBulkAuction(auctionId: string, btn: HTMLButtonElement | null) {
    this.setActionButtonLoading(btn, true);
    this.reportService
      .vehicleRecycle(auctionId)
      .pipe(finalize(() => this.setActionButtonLoading(btn, false)))
      .subscribe((res) => {
        if (res['success']) {
          this.router.navigate([`/dashboard/auction/edit/${auctionId}`], {
            queryParams: { type: 'bulk' },
          });
          localStorage.setItem("for-recyle", "true")
        }
      });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}

@Pipe({ name: 'removeUnderscore' })
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value.replace(/_/g, ' ');
  }
}